import React from 'react'
import cn from '#/utils/classnames'
import styles from './styles.module.scss'

interface BreadcrumbProps {
  className?: string
  children: React.ReactNode
}

export default function Breadcrumb({ className, children }: BreadcrumbProps) {
  return (
    <div className={cn(styles['th-breadcrumb'], className)}>
      {children}
    </div>
  )
}

Breadcrumb.Item = function ({ className, children }: BreadcrumbProps) {
  return (
    <span className={cn(styles['th-breadcrumb-item'], className)}>
      {children}
    </span>
  )
}
